export class DragDropValueEvent<VALUE = Array<string>> extends Event {
  constructor(
    type: string,
    public readonly value: VALUE,
  ) {
    super(type);
    this.value = value;
  }
}
